import { Panne, InstalledSparepart } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"

function mapInstalledSparePart(input: any): InstalledSparepart {
    return {
        id: input.id,
        sparepartId: input.sparepartId ?? input.sparePartId,
        taskId: input.taskId,
        panneId: input.panneId,
        quantity: input.quantity,
        displayName: input.displayName
    };
}

function modelMapper(inputPanne: any): Panne {
    const sparepartsList = inputPanne.installedSpareparts ?? inputPanne.installedSpareParts ?? [];
    return {
        id: inputPanne.id,
        creationDate: inputPanne.creationDate,
        reparationDate: inputPanne.reparationDate,
        name: inputPanne.name,
        desc: inputPanne.desc,
        createTask: inputPanne.createTask,
        repaired: inputPanne.repaired,
        installedSpareParts: sparepartsList.map(mapInstalledSparePart)
    };
}

export function modelMapperArray(inputArray: any[]): Panne[] {
    return inputArray.map(modelMapper);
}

export async function getPanneByProduct(productId: string, repaired?: boolean): Promise<Panne[]> {
    const query = repaired !== undefined ? `?repaired=${repaired}` : "";
    const pannes = await getData<Panne[]>("products/" + productId + "/pannes" + query);
    return modelMapperArray(pannes ?? []);
}

export function getPanneById(panneId: string): Promise<Panne> {
    return getData("pannes/" + panneId).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postPanne(panne: Panne, productId: string): Promise<Panne> {
    return postData("products/" + productId + "/pannes", panne).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putPanne(panne: Panne): Promise<any> {
    return putData("pannes/" + panne.id, panne)
}

export function deletePanne(panneId: string): Promise<any> {
    return deleteData("pannes/" + panneId)
}